import React from "react"

import {Typography} from "antd";

import EventSingle from "../theme/components/EventSingle";
import logger from "../../../services/logger"
import {fetchEvents} from "../../../services/EventService";

const {Text}=Typography

export default class EventRender extends React.Component{

    state = { events: [], eventGroupes: [], loading: true }

    componentDidMount() {
        const org = this.props.context?.org
        if (org) fetchEvents(org.id, {virtualId: org.virtualId || null}).then(d => this.setState({ events: d.events, eventGroupes: d.eventGroupes, loading: false }))
        else this.setState({ loading: false })
    }

    render()
    {
        const context=this.props.context
        const {org}=context
        const events = this.state.events
        // L'événement (affiche ou PE) est résolu via le fetch client des événements.
        const eventKey = context.page?.eventId || context.route[1]
        const item=(events || []).find(i=>i.id===eventKey)

        // Pendant le chargement, ne rien afficher pour ne pas flasher un état "introuvable".
        if(this.state.loading){
            return null
        }

        logger.debug({ item }, "item")

        return (
            <EventSingle
                context={context}
                item={item}
            />
        )

    }
}

/*

*/
